<div class="header">
  <h2>{{ "pages.dozent.participants.title" | translate }}</h2>
</div>

<div class="search">
  <div class="search-field-wrapper">
    <nb-form-field>
      <input
        type="text"
        nbInput
        fullWidth
        [placeholder]="'menu.searchPlaceholder' | translate"
        [(ngModel)]="searchText"
        (ngModelChange)="onCourseSearchChange()"
      />
      <button nbSuffix nbButton ghost>
        @if (searchText && searchText.length > 0) {
          <nb-icon icon="close-outline" (click)="searchText = ''; onCourseSearchChange()"></nb-icon>
        } @else {
          <nb-icon icon="search-outline" pack="eva"></nb-icon>
        }
      </button>
    </nb-form-field>
  </div>
  <button
    nbButton
    status="primary"
    (click)="onRefreshMoodleSync()"
    [disabled]="isSyncing"
    [nbSpinner]="isSyncing"
    nbSpinnerSize="tiny"
    nbSpinnerStatus="control"
    [nbTooltip]="'pages.dozent.participants.syncMoodleTooltip' | translate"
  >
    <nb-icon icon="sync-outline"></nb-icon>
    {{ "pages.dozent.participants.syncMoodleData" | translate }}
  </button>
</div>

<div *ngIf="syncProgress" class="sync-progress">
  <div class="sync-progress-header">
    <nb-icon
      [icon]="syncProgressIcon"
      [class.spin]="syncProgressRunning"
    ></nb-icon>
    <span>{{ syncProgressLabel }}</span>
  </div>
  <nb-progress-bar
    [status]="syncProgressStatus"
    [value]="syncProgressPercent"
  ></nb-progress-bar>
</div>

<app-page-loader *ngIf="isLoading && courses.length === 0"></app-page-loader>

<div class="grid" *ngIf="!isLoading || courses.length > 0">
  <!-- Left: Course List -->
  <nb-card size="small" class="course-list-card" alAnchor="dozent.course-list">
    <div class="course-list-toolbar" *ngIf="filteredCourses.length > 0">
      <button
        nbButton
        size="small"
        status="primary"
        appearance="ghost"
        (click)="toggleCourseSort()"
        [nbTooltip]="
          courseSortDirection === 'asc'
            ? ('pages.dozent.participants.sortCourseAsc' | translate)
            : ('pages.dozent.participants.sortCourseDesc' | translate)
        "
      >
        <nb-icon
          [icon]="
            courseSortDirection === 'asc'
              ? 'arrow-upward-outline'
              : 'arrow-downward-outline'
          "
        ></nb-icon>
        {{
          courseSortDirection === 'asc'
            ? ('pages.dozent.participants.sortAz' | translate)
            : ('pages.dozent.participants.sortZa' | translate)
        }}
      </button>
      <app-pagination
        class="course-pagination toolbar-pagination"
        [totalItems]="courseTotal"
        [itemsPerPage]="coursePageSize"
        [currentPage]="coursePage"
        [pageSizeOptions]="coursePageSizeOptions"
        (pageChanged)="onCoursePageChange($event)"
        (itemsPerPageChange)="onCoursePageSizeChange($event)"
      ></app-pagination>
    </div>

    <nb-list *ngIf="filteredCourses.length > 0">
      <nb-list-item
        *ngFor="let course of pagedCourses"
        alAnchor="dozent.course-row"
        [ngClass]="{ selected: selectedCourse?.id === course.id }"
        (click)="onSelectCourse(course)"
      >
        <div class="folder">
          <nb-icon icon="book-outline"></nb-icon>
          <div class="labels">
            <p class="name">{{ course.name || course.course_name }}</p>
            <p class="description">
              <span
                class="source-pill"
                [class.moodle]="!!course.moodle_course_id || !!course.original_course_id"
              >
                {{ (course.moodle_course_id || course.original_course_id) ? 'Moodle' : 'Manuell' }}
              </span>
              <span *ngIf="course.participant_count != null">
                · {{ course.participant_count }} {{ "pages.dozent.participants.participantsBadge" | translate }}
              </span>
            </p>
          </div>

          <div class="actions">
            <button
              nbButton
              ghost
              status="danger"
              (click)="onDeleteCourse(course, $event)"
            >
              <nb-icon icon="trash"></nb-icon>
            </button>
          </div>
        </div>
      </nb-list-item>
    </nb-list>
    <nb-card-body *ngIf="filteredCourses.length === 0" class="empty-sidebar">
      <nb-icon icon="book-outline"></nb-icon>
      <p>{{ "pages.dozent.participants.noCourses" | translate }}</p>
    </nb-card-body>
  </nb-card>

  <!-- Right: Course Detail Panel.
       The participant detail (general / profile / exercises /
       communication tabs) opens as a modal via
       openParticipantDetail() — it no longer replaces this card
       inline. Triggered from name click, eye icon, and pencil icon
       in the Teilnehmende table below. -->
  <nb-card size="small" class="detail-card panel-enter" alAnchor="dozent.participant-detail">
    <!-- No course selected -->
    <nb-card-body *ngIf="!selectedCourse" class="empty-panel">
      <nb-icon icon="arrow-back-outline"></nb-icon>
      <p>{{ "pages.dozent.participants.selectCourseFirst" | translate }}</p>
    </nb-card-body>

    <!-- Course selected: Tabs -->
    <nb-tabset *ngIf="selectedCourse">
      <!-- Tab 1: Course Info -->
      <nb-tab tabId="course-info" tabTitle="{{ 'pages.dozent.participants.tabCourseInfo' | translate }}">
        <div class="course-info-panel">
          <div class="info-row">
            <label>{{ "input.name.label" | translate }}</label>
            <span>{{ selectedCourse.name || selectedCourse.course_name }}</span>
          </div>
          <div class="info-row" *ngIf="selectedCourse.description">
            <label>{{ "input.description.label" | translate }}</label>
            <span>{{ selectedCourse.description }}</span>
          </div>
          <div class="info-row">
            <label>{{ "pages.dozent.participants.source" | translate }}</label>
            <span class="source-pill" [class.moodle]="!!selectedCourse.moodle_course_id || !!selectedCourse.original_course_id">
              {{ (selectedCourse.moodle_course_id || selectedCourse.original_course_id) ? 'Moodle' : 'Manuell' }}
            </span>
          </div>
          <div class="info-row" *ngIf="selectedCourse.created_at">
            <label>{{ "pages.dozent.participants.createdAt" | translate }}</label>
            <span>{{ selectedCourse.created_at | date: "dd.MM.yyyy" }}</span>
          </div>
          <div class="info-row" *ngIf="selectedCourse.participant_count != null">
            <label>{{ "pages.dozent.participants.participantCount" | translate }}</label>
            <span>{{ selectedCourse.participant_count }}</span>
          </div>
        </div>
      </nb-tab>

      <!-- Tab 2: Participants -->
      <nb-tab tabId="participants" tabTitle="{{ 'pages.dozent.participants.tabParticipants' | translate }}">
        <div class="tab-header">
          <app-pagination
            *ngIf="!isLoadingParticipants && filteredParticipants.length > 0"
            class="table-pagination toolbar-pagination"
            [totalItems]="participantTotal"
            [itemsPerPage]="participantPageSize"
            [currentPage]="participantPage"
            [pageSizeOptions]="participantPageSizeOptions"
            (pageChanged)="onParticipantPageChange($event)"
            (itemsPerPageChange)="onParticipantPageSizeChange($event)"
          ></app-pagination>
          <div class="tab-actions">
            <button
              *ngIf="selectedCourseIsMoodle"
              nbButton
              size="small"
              status="primary"
              appearance="ghost"
              (click)="onRefreshSelectedCourseParticipants()"
              [disabled]="isSyncingSelectedCourse"
              [nbSpinner]="isSyncingSelectedCourse"
              nbSpinnerSize="tiny"
              nbSpinnerStatus="primary"
              [nbTooltip]="'pages.dozent.participants.syncSelectedCourseTooltip' | translate"
            >
              <nb-icon icon="sync-outline"></nb-icon>
              {{ "pages.dozent.participants.syncSelectedCourse" | translate }}
            </button>
          </div>
        </div>

        <app-page-loader *ngIf="isLoadingParticipants"></app-page-loader>

        <div
          *ngIf="!isLoadingParticipants && hasPseudonymizedParticipants"
          class="pseudonym-notice"
        >
          <nb-icon icon="info-outline"></nb-icon>
          <div>
            <strong>{{ "pages.dozent.participants.pseudonymNoticeTitle" | translate }}</strong>
            <p>{{ "pages.dozent.participants.pseudonymNoticeBody" | translate }}</p>
          </div>
        </div>

        <!-- Participants Table -->
        <div *ngIf="!isLoadingParticipants && filteredParticipants.length > 0" class="table-body">
          <table class="participants-table">
            <thead>
              <tr>
                <th>{{ "input.fullName.label" | translate }}</th>
                <th>{{ "input.email.label" | translate }}</th>
                <th>{{ "pages.dozent.participants.source" | translate }}</th>
                <th>{{ "words.status" | translate }}</th>
                <th>{{ "pages.dozent.participants.grade" | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of pagedParticipants">
                <ng-container *ngIf="editingParticipant?.id !== p.id">
                  <td class="clickable-name" alAnchor="dozent.participant-name" (click)="openParticipantDetail(p)">
                    <span class="presence-dot" [class.online]="isOnline(p)"></span>
                    {{ getParticipantName(p) }}
                    <span
                      *ngIf="p.learner_user_id"
                      class="known-badge"
                      [nbTooltip]="'pages.dozent.participants.knownLearnerTooltip' | translate"
                    >
                      <nb-icon icon="checkmark-circle-2"></nb-icon>
                    </span>
                    <nb-icon icon="person-outline" class="profile-icon"></nb-icon>
                  </td>
                  <td>{{ p.email ?? "—" }}</td>
                  <td>
                    <span class="inline-badge" [class.moodle]="p.enrollment_source === 'moodle'">
                      {{ getSourceBadge(p.enrollment_source) }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="inline-badge"
                      [class.active]="p.enrollment_status === 'active'"
                      [class.inactive]="p.enrollment_status !== 'active'"
                    >
                      {{ p.enrollment_status }}
                    </span>
                  </td>
                  <td>{{ p.moodle_grade_total ?? "—" }}</td>
                  <td>
                    <div class="action-btns">
                      <!-- Eye → open full detail modal (read).
                           Pencil → inline-edit name + email in this
                           row (quick edit). The two icons intentionally
                           do different things so the user can choose
                           between deep view and fast rename. -->
                      <button
                        nbButton ghost size="tiny" status="info"
                        (click)="openParticipantDetail(p)"
                        [nbTooltip]="'pages.dozent.participants.viewProfile' | translate"
                      >
                        <nb-icon icon="eye-outline"></nb-icon>
                      </button>
                      <button
                        nbButton ghost size="tiny" status="primary"
                        (click)="onEditParticipant(p)"
                      >
                        <nb-icon icon="edit-outline"></nb-icon>
                      </button>
                      <button
                        nbButton ghost size="tiny" status="danger"
                        (click)="onRemoveParticipant(p)"
                      >
                        <nb-icon icon="trash-outline"></nb-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>
                <ng-container *ngIf="editingParticipant?.id === p.id">
                  <td>
                    <div class="edit-name-row">
                      <input nbInput size="small" [(ngModel)]="editModel.first_name" placeholder="{{ 'pages.dozent.participants.firstName' | translate }}" />
                      <input nbInput size="small" [(ngModel)]="editModel.last_name" placeholder="{{ 'pages.dozent.participants.lastName' | translate }}" />
                    </div>
                  </td>
                  <td>
                    <input nbInput size="small" [(ngModel)]="editModel.email" placeholder="{{ 'input.email.placeholder' | translate }}" />
                  </td>
                  <td>
                    <span class="inline-badge" [class.moodle]="p.enrollment_source === 'moodle'">
                      {{ getSourceBadge(p.enrollment_source) }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="inline-badge"
                      [class.active]="p.enrollment_status === 'active'"
                      [class.inactive]="p.enrollment_status !== 'active'"
                    >
                      {{ p.enrollment_status }}
                    </span>
                  </td>
                  <td>{{ p.moodle_grade_total ?? "—" }}</td>
                  <td>
                    <div class="action-btns">
                      <button nbButton ghost size="tiny" status="success" (click)="onSaveEdit()">
                        <nb-icon icon="checkmark-outline"></nb-icon>
                      </button>
                      <button nbButton ghost size="tiny" (click)="onCancelEdit()">
                        <nb-icon icon="close-outline"></nb-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          *ngIf="!isLoadingParticipants && filteredParticipants.length === 0"
          class="empty-state-inline"
        >
          <p>{{ "pages.dozent.participants.noParticipants" | translate }}</p>
        </div>
      </nb-tab>

      <!-- Tab 3: Übungen -->
      <nb-tab tabTitle="{{ 'pages.dozent.participants.tabExercises' | translate }}">
        <div class="tab-header">
          <app-pagination
            *ngIf="!isLoadingAssignments && courseAssignments.length > 0"
            class="table-pagination toolbar-pagination"
            [totalItems]="courseAssignments.length"
            [itemsPerPage]="assignmentPageSize"
            [currentPage]="assignmentPage"
            [pageSizeOptions]="assignmentPageSizeOptions"
            (pageChanged)="onAssignmentPageChange($event)"
            (itemsPerPageChange)="onAssignmentPageSizeChange($event)"
          ></app-pagination>
          <div class="tab-actions">
            <button
              nbButton
              size="small"
              status="primary"
              (click)="openDispatchExerciseDialog()"
            >
              <nb-icon icon="paper-plane-outline"></nb-icon>
              {{ "pages.dozent.participants.dispatchExercise" | translate }}
            </button>
          </div>
        </div>

        <app-page-loader *ngIf="isLoadingAssignments"></app-page-loader>

        <div *ngIf="!isLoadingAssignments && courseAssignments.length > 0" class="table-body">
          <table class="participants-table">
            <thead>
              <tr>
                <th>{{ "input.name.label" | translate }}</th>
                <th>{{ "pages.dozent.participants.exerciseType" | translate }}</th>
                <th>{{ "pages.dozent.participants.recipients" | translate }}</th>
                <th>{{ "pages.dozent.participants.scheduledPublishAtShort" | translate }}</th>
                <th>{{ "pages.dozent.participants.dueDate" | translate }}</th>
                <th>{{ "words.status" | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of pagedCourseAssignments">
                <td>{{ a.exercise_title || a.title }}</td>
                <td>
                  <span class="inline-badge">{{ a.exercise_type }}</span>
                </td>
                <td>{{ a.participant_count }}</td>
                <td>
                  {{ a.scheduled_publish_at ? (a.scheduled_publish_at | date: "dd.MM.yyyy HH:mm") : "—" }}
                </td>
                <td>{{ a.due_date ? (a.due_date | date: "dd.MM.yyyy HH:mm") : "—" }}</td>
                <td>
                  <span class="inline-badge" [class.active]="a.status === 'published'">
                    {{ a.status }}
                  </span>
                </td>
                <td>
                  <div class="action-btns">
                    <button
                      nbButton ghost size="tiny" status="info"
                      (click)="openSubmissionReview(a)"
                      [nbTooltip]="'pages.dozent.participants.reviewSubmissions' | translate"
                    >
                      <nb-icon icon="clipboard-outline"></nb-icon>
                    </button>
                    <button
                      nbButton ghost size="tiny" status="danger"
                      (click)="onDeleteAssignment(a)"
                    >
                      <nb-icon icon="trash-outline"></nb-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          *ngIf="!isLoadingAssignments && courseAssignments.length === 0"
          class="empty-state-inline"
        >
          <p>{{ "pages.dozent.participants.noAssignments" | translate }}</p>
        </div>
      </nb-tab>
    </nb-tabset>
  </nb-card>
</div>
